module.exports = __webpack_public_path__ + "img/spain.056dd515.jpg";